import './DefaultResetPassword.css';
import React from 'react';
import { CenterFrameLayout } from 'Layouts';

const DefaultResetPassword = ({ renderBody, title }) => {
  return (
    <CenterFrameLayout noPanel title={title} customClass="passwordResetContainer" showLoader={false}>
      <div className="roundContentContainer">{renderBody()}</div>
    </CenterFrameLayout>
  );
};

export default DefaultResetPassword;
